import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useState } from "react";
import Sidebar from "../components/Sidebar"; // Adjust the path as needed
import api from "../utils/api";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";


const PromoCodes = () => {
  const [promoCode, setPromoCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [usageLimit, setUsageLimit] = useState("");
  const [unlimitedUsage, setUnlimitedUsage] = useState(false);
  const [selectedType, setSelectedType] = useState("all"); // Default type is "all"
  const { token } = useAuth();

  const handleUnlimitedUsage = () => {
    setUnlimitedUsage(!unlimitedUsage);
    if (!unlimitedUsage) {
      setUsageLimit("");
    }
  };

  const handleSubmit = async () => {
    const formData = {
      couponCode: promoCode,
      discountPercentage: parseInt(discount),
      status: "active",
      limit: unlimitedUsage ? 1000000 : parseInt(usageLimit),
      type: selectedType,
    };

    try {
      const response = await api.post("/coupons", formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Coupon created successfully:", response.data);
      toast.success("Promo Code saved successfully!");
    } catch (error) {
      console.error("Error creating promo code:", error);
      toast.error("Failed to save promo code. Please try again.");


    }
  };

  return (
    <div className="flex flex-col md:flex-row">
      {/* Sidebar */}
      <Sidebar />
      <ToastContainer />

      {/* Main Content */}
      <div className="flex-1 bg-gray-50 p-4  lg:mt-24">
        <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl mx-auto">
          <h1 className="text-xl md:text-2xl font-bold text-gray-700 mb-6 text-center">Set Promo Code</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Promo Code Input */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">New Promo Code</label>
              <input
                type="text"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value.toUpperCase())} // Convert to uppercase
                placeholder="Enter promo code"
                className="w-full border rounded-lg px-4 py-2 focus:outline-none focus:ring focus:border-blue-500"
              />
            </div>


            {/* Discount Input */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">Discount %</label>
              <input
                type="number"
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
                placeholder="Enter discount percentage"
                className="w-full border rounded-lg px-4 py-2 focus:outline-none focus:ring focus:border-blue-500"
              />
            </div>

            {/* Usage Limit */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">Usage Limit</label>
              <input
                type="number"
                value={unlimitedUsage ? "" : usageLimit}
                onChange={(e) => setUsageLimit(e.target.value)}
                placeholder="Enter usage limit"
                disabled={unlimitedUsage}
                className="w-full border rounded-lg px-4 py-2 focus:outline-none focus:ring focus:border-blue-500"
              />
            </div>

            {/* Unlimited Usage Toggle */}
            <div className="flex items-center justify-start">
              <button
                onClick={handleUnlimitedUsage}
                className={`px-6 py-3 rounded-lg text-black mt-4 font-medium w-full md:w-auto ${unlimitedUsage ? "bg-green-500 text-white" : "bg-gray-300"
                  }`}
              >
                {unlimitedUsage ? "Unlimited Usage Enabled" : "Enable Unlimited Usage"}
              </button>
            </div>
          </div>

          {/* Checkbox Options */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
            <label
              className={`px-6 py-3 rounded-lg font-medium text-white w-full cursor-pointer ${selectedType === "all" ? "bg-green-600" : "bg-gray-800"
                }`}
              onClick={() => setSelectedType("all")}
            >
              <div className="flex items-center">
                <input type="checkbox" checked={selectedType === "all"} readOnly className="mr-2" />
                <span>Applicable for all consoles</span>
              </div>
            </label>

            <label
              className={`px-6 py-3 rounded-lg font-medium text-white w-full cursor-pointer ${selectedType === "XB" ? "bg-green-600" : "bg-gray-800"
                }`}
              onClick={() => setSelectedType("XB")}
            >
              <div className="flex items-center">
                <input type="checkbox" checked={selectedType === "XB"} readOnly className="mr-2" />
                <span>Applicable for Xbox</span>
              </div>
            </label>

            <label
              className={`px-6 py-3 rounded-lg font-medium text-white w-full cursor-pointer ${selectedType === "PS" ? "bg-green-600" : "bg-gray-800"
                }`}
              onClick={() => setSelectedType("PS")}
            >
              <div className="flex items-center">
                <input type="checkbox" checked={selectedType === "PS"} readOnly className="mr-2" />
                <span>Applicable for PS</span>
              </div>
            </label>

            <label
              className={`px-6 py-3 rounded-lg font-medium text-white w-full cursor-pointer ${selectedType === "PC" ? "bg-green-600" : "bg-gray-800"
                }`}
              onClick={() => setSelectedType("PC")}
            >
              <div className="flex items-center">
                <input type="checkbox" checked={selectedType === "PC"} readOnly className="mr-2" />
                <span>Applicable for PC</span>
              </div>
            </label>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col md:flex-row justify-between mt-8 space-y-4 md:space-y-0 md:space-x-4">
            <button
              onClick={() => console.log("Back to previous page")}
              className="px-6 py-3 bg-gray-300 text-black rounded-lg w-full md:w-auto hover:bg-gray-400"
            >
              Back
            </button>
            <button
              onClick={handleSubmit}
              className="px-6 py-3 bg-green-500 text-white rounded-lg w-full md:w-auto hover:bg-green-600"
            >
              Generate Coupon
            </button>
            <Link to="/admin/active-promo-codes"
              className="px-6 py-3 bg-blue-500 text-white rounded-lg w-full text-center md:w-auto hover:bg-blue-600"
            >
              Active Promo Codes
            </Link>

          </div>
        </div>
      </div>
    </div>
  );

};

export default PromoCodes;
